import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import {
	ConsoleShell,
	SidebarNav,
	SidebarNavLink,
} from "../../components/console-shell.tsx";
import { ACCOUNT_SECTIONS } from "../../navigation.ts";

/**
 * Your account, as opposed to any business you belong to.
 *
 * Guarded on the layout for the same reason `/dashboard` and `/admin` are: a
 * screen added underneath inherits the check instead of having to remember it.
 */
export const Route = createFileRoute("/settings")({
	beforeLoad: async ({ context, location }) => {
		const session = await context.queryClient.ensureQueryData(
			context.trpc.session.queryOptions(),
		);

		if (session.user === null) {
			throw redirect({ to: "/sign-in", search: { redirect: location.href } });
		}

		return { session };
	},
	component: SettingsLayout,
});

function SettingsLayout() {
	return (
		<ConsoleShell
			sidebar={
				<SidebarNav label="Settings">
					{ACCOUNT_SECTIONS.map((section) => (
						<SidebarNavLink
							key={section.to}
							to={section.to}
							label={section.label}
							icon={section.icon}
							exact={section.exact}
						/>
					))}
				</SidebarNav>
			}
		>
			<Outlet />
		</ConsoleShell>
	);
}
